module.exports = __webpack_public_path__ + "static/assets/c4f25806035a880699d026773bc23943.svg";